var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2023_55)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H53V53H0V0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 48,
    width: 52,
    height: 4,
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 52,
    height: 4,
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 52,
    height: 4,
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 52,
    height: 4,
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 52,
    height: 4,
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 52,
    height: 4,
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 4,
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.552 3.06348L25.5538 2.35971L26.5225 3.06348L26.2217 1.81325L27 1.02116H26.0092L25.5524 0L25.1633 1.02116H24L24.8901 1.81325L24.552 3.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.552 9.06348L25.5538 8.35971L26.5225 9.06348L26.2217 7.81325L27 7.02116H26.0092L25.5524 6L25.1633 7.02116H24L24.8901 7.81325L24.552 9.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.552 15.0635L25.5538 14.3597L26.5225 15.0635L26.2217 13.8132L27 13.0212H26.0092L25.5524 12L25.1633 13.0212H24L24.8901 13.8132L24.552 15.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.552 21.0635L25.5538 20.3597L26.5225 21.0635L26.2217 19.8132L27 19.0212H26.0092L25.5524 18L25.1633 19.0212H24L24.8901 19.8132L24.552 21.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.552 27.0635L25.5538 26.3597L26.5225 27.0635L26.2217 25.8132L27 25.0212H26.0092L25.5524 24L25.1633 25.0212H24L24.8901 25.8132L24.552 27.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.552 3.06348L19.5538 2.35971L20.5225 3.06348L20.2217 1.81325L21 1.02116H20.0092L19.5524 0L19.1633 1.02116H18L18.8901 1.81325L18.552 3.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.552 9.06348L19.5538 8.35971L20.5225 9.06348L20.2217 7.81325L21 7.02116H20.0092L19.5524 6L19.1633 7.02116H18L18.8901 7.81325L18.552 9.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.552 15.0635L19.5538 14.3597L20.5225 15.0635L20.2217 13.8132L21 13.0212H20.0092L19.5524 12L19.1633 13.0212H18L18.8901 13.8132L18.552 15.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.552 21.0635L19.5538 20.3597L20.5225 21.0635L20.2217 19.8132L21 19.0212H20.0092L19.5524 18L19.1633 19.0212H18L18.8901 19.8132L18.552 21.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.552 27.0635L19.5538 26.3597L20.5225 27.0635L20.2217 25.8132L21 25.0212H20.0092L19.5524 24L19.1633 25.0212H18L18.8901 25.8132L18.552 27.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.552 3.06348L13.5538 2.35971L14.5225 3.06348L14.2217 1.81325L15 1.02116H14.0092L13.5524 0L13.1633 1.02116H12L12.8901 1.81325L12.552 3.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.552 9.06348L13.5538 8.35971L14.5225 9.06348L14.2217 7.81325L15 7.02116H14.0092L13.5524 6L13.1633 7.02116H12L12.8901 7.81325L12.552 9.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.552 15.0635L13.5538 14.3597L14.5225 15.0635L14.2217 13.8132L15 13.0212H14.0092L13.5524 12L13.1633 13.0212H12L12.8901 13.8132L12.552 15.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.552 21.0635L13.5538 20.3597L14.5225 21.0635L14.2217 19.8132L15 19.0212H14.0092L13.5524 18L13.1633 19.0212H12L12.8901 19.8132L12.552 21.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.552 27.0635L13.5538 26.3597L14.5225 27.0635L14.2217 25.8132L15 25.0212H14.0092L13.5524 24L13.1633 25.0212H12L12.8901 25.8132L12.552 27.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55198 3.06348L7.55382 2.35971L8.52254 3.06348L8.22171 1.81325L9 1.02116H8.0092L7.55244 0L7.16329 1.02116H6L6.89006 1.81325L6.55198 3.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55198 9.06348L7.55382 8.35971L8.52254 9.06348L8.22171 7.81325L9 7.02116H8.0092L7.55244 6L7.16329 7.02116H6L6.89006 7.81325L6.55198 9.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55198 15.0635L7.55382 14.3597L8.52254 15.0635L8.22171 13.8132L9 13.0212H8.0092L7.55244 12L7.16329 13.0212H6L6.89006 13.8132L6.55198 15.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55198 21.0635L7.55382 20.3597L8.52254 21.0635L8.22171 19.8132L9 19.0212H8.0092L7.55244 18L7.16329 19.0212H6L6.89006 19.8132L6.55198 21.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55198 27.0635L7.55382 26.3597L8.52254 27.0635L8.22171 25.8132L9 25.0212H8.0092L7.55244 24L7.16329 25.0212H6L6.89006 25.8132L6.55198 27.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.551977 3.06348L1.55382 2.35971L2.52254 3.06348L2.22171 1.81325L3 1.02116H2.0092L1.55244 0L1.16329 1.02116H0L0.890062 1.81325L0.551977 3.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.551977 9.06348L1.55382 8.35971L2.52254 9.06348L2.22171 7.81325L3 7.02116H2.0092L1.55244 6L1.16329 7.02116H0L0.890062 7.81325L0.551977 9.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.551977 15.0635L1.55382 14.3597L2.52254 15.0635L2.22171 13.8132L3 13.0212H2.0092L1.55244 12L1.16329 13.0212H0L0.890062 13.8132L0.551977 15.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.551977 21.0635L1.55382 20.3597L2.52254 21.0635L2.22171 19.8132L3 19.0212H2.0092L1.55244 18L1.16329 19.0212H0L0.890062 19.8132L0.551977 21.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.551977 27.0635L1.55382 26.3597L2.52254 27.0635L2.22171 25.8132L3 25.0212H2.0092L1.55244 24L1.16329 25.0212H0L0.890062 25.8132L0.551977 27.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.552 6.06348L22.5538 5.35971L23.5225 6.06348L23.2217 4.81325L24 4.02116H23.0092L22.5524 3L22.1633 4.02116H21L21.8901 4.81325L21.552 6.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.552 12.0635L22.5538 11.3597L23.5225 12.0635L23.2217 10.8132L24 10.0212H23.0092L22.5524 9L22.1633 10.0212H21L21.8901 10.8132L21.552 12.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.552 18.0635L22.5538 17.3597L23.5225 18.0635L23.2217 16.8132L24 16.0212H23.0092L22.5524 15L22.1633 16.0212H21L21.8901 16.8132L21.552 18.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.552 24.0635L22.5538 23.3597L23.5225 24.0635L23.2217 22.8132L24 22.0212H23.0092L22.5524 21L22.1633 22.0212H21L21.8901 22.8132L21.552 24.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.552 6.06348L16.5538 5.35971L17.5225 6.06348L17.2217 4.81325L18 4.02116H17.0092L16.5524 3L16.1633 4.02116H15L15.8901 4.81325L15.552 6.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.552 12.0635L16.5538 11.3597L17.5225 12.0635L17.2217 10.8132L18 10.0212H17.0092L16.5524 9L16.1633 10.0212H15L15.8901 10.8132L15.552 12.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.552 18.0635L16.5538 17.3597L17.5225 18.0635L17.2217 16.8132L18 16.0212H17.0092L16.5524 15L16.1633 16.0212H15L15.8901 16.8132L15.552 18.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.552 24.0635L16.5538 23.3597L17.5225 24.0635L17.2217 22.8132L18 22.0212H17.0092L16.5524 21L16.1633 22.0212H15L15.8901 22.8132L15.552 24.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55198 6.06348L10.5538 5.35971L11.5225 6.06348L11.2217 4.81325L12 4.02116H11.0092L10.5524 3L10.1633 4.02116H9L9.89006 4.81325L9.55198 6.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55198 12.0635L10.5538 11.3597L11.5225 12.0635L11.2217 10.8132L12 10.0212H11.0092L10.5524 9L10.1633 10.0212H9L9.89006 10.8132L9.55198 12.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55198 18.0635L10.5538 17.3597L11.5225 18.0635L11.2217 16.8132L12 16.0212H11.0092L10.5524 15L10.1633 16.0212H9L9.89006 16.8132L9.55198 18.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55198 24.0635L10.5538 23.3597L11.5225 24.0635L11.2217 22.8132L12 22.0212H11.0092L10.5524 21L10.1633 22.0212H9L9.89006 22.8132L9.55198 24.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55198 6.06348L4.55382 5.35971L5.52254 6.06348L5.22171 4.81325L6 4.02116H5.0092L4.55244 3L4.16329 4.02116H3L3.89006 4.81325L3.55198 6.06348Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55198 12.0635L4.55382 11.3597L5.52254 12.0635L5.22171 10.8132L6 10.0212H5.0092L4.55244 9L4.16329 10.0212H3L3.89006 10.8132L3.55198 12.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55198 18.0635L4.55382 17.3597L5.52254 18.0635L5.22171 16.8132L6 16.0212H5.0092L4.55244 15L4.16329 16.0212H3L3.89006 16.8132L3.55198 18.0635Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55198 24.0635L4.55382 23.3597L5.52254 24.0635L5.22171 22.8132L6 22.0212H5.0092L4.55244 21L4.16329 22.0212H3L3.89006 22.8132L3.55198 24.0635Z",
    fill: "#F7FCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2023_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEng);
export default __webpack_public_path__ + "static/media/eng.cbd28c0252e9df766d137352cb4fc405.svg";
export { ForwardRef as ReactComponent };